import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const campaignAdMapItemSchema = z
  .object({
    ad_id: z.number(),
    ad_name: z.string(),
    auto_campaign_name: z.string().nullable().optional(),
    contextual_campaign_name: z.string().nullable().optional(),
    manual_campaign_name: z.string().nullable().optional(),
    audience_campaign_name: z.string().nullable().optional(),
  })
  .passthrough();

export type CampaignAdMapItem = z.infer<typeof campaignAdMapItemSchema>;

const paginatedCampaignAdMapResponseSchema = z.object({
  count: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
  results: z.array(campaignAdMapItemSchema),
});

const campaignAdMapResponseSchema = z.union([
  z.array(campaignAdMapItemSchema),
  z
    .object({
      data: z.array(campaignAdMapItemSchema),
    })
    .passthrough(),
  paginatedCampaignAdMapResponseSchema,
]);

export type CampaignAdMapResponse = z.infer<typeof campaignAdMapResponseSchema>;

export const campaignAdMapApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "listCampaignAdMap",
    method: "get",
    path: "/campaign_ad_map",
    parameters: [
      { name: "marketplace", type: "Query", schema: z.string().optional() },
      { name: "campaign_name", type: "Query", schema: z.string().optional() },
      { name: "campaign_id", type: "Query", schema: z.number().optional() },
      { name: "campaign_group", type: "Query", schema: z.string().optional() },
      { name: "campaign_names", type: "Query", schema: z.string().optional() },
      { name: "page", type: "Query", schema: z.number().min(1).optional() },
      { name: "page_size", type: "Query", schema: z.number().min(1).optional() },
    ],
    status: 200,
    response: campaignAdMapResponseSchema,
  }).build(),
);
